"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dynamicColumnStatusMap = void 0;
exports.dynamicColumnStatusMap = {
    'pending-migration': 'Pending Migration',
    migrating: 'Migrating',
    active: 'Active',
    error: 'Error',
};
